import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import { Height } from "@material-ui/icons";

/**
 * Contains style information for the documnents page.
 */
export const InspectionPageStyles = makeStyles((theme: Theme) => ({
    root: {},
    stages: {
        padding: "20px 0 16px 0",
        overflowY: "auto",
    },
    stage: {
        display: "flex",
        margin: "0 18px",
        "& > div:first-child": {
            minHeight: "80px",
            minWidth: "80px",
            position: "relative",
            "@media (max-width: 767px)": {
                minWidth: "58px",
                minHeight: "58px",
            },
            "& > div": {
                position: "absolute",
            },
            // Link element.
            "& > div:first-child": {
                backgroundColor: "#ced4da",
                minHeight: "10%",
                minWidth: "8px",
                transform: "translate(26px, 0px)",
                "@media (max-width: 767px)": {
                    display: "none",
                },
            },
            "& > div:last-child": {
                backgroundColor: "#ced4da",
                minHeight: "15%",
                minWidth: "8px",
                transform: "translate(26px, 0px)",
                bottom: "0",
                "@media (max-width: 767px)": {
                    display: "none",
                },
            },
        },
        // First progress element.
        "&:nth-child(2)": {
            "& > div:first-child": {
                // Link element.
                "& > div:first-child": {
                    display: "none",
                },
            },
        },
        // Last progress element.
        "&:last-child": {
            "& > div:first-child": {
                // Link element.
                "& > div:last-child": {
                    display: "none",
                },
            },
        },
    },
    activeStage: {
        margin: "0 7px",
    },
    stageTextRow: {
        color: "#808080",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginLeft: "0",
    },
    stageIcon: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginLeft: "auto",
        "@media (max-width: 767px)": {
            gap: "6px",
        },
    },
    stageTitle: {
        fontSize: "14px",
        fontWeight: "bold",
        textTransform: "uppercase",
    },
    stageSubTitle: {
        fontSize: "12px",
    },
    stageDocumentBlock: {
        marginTop: "20px",
    },
    imageCard: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
    },
    stageContainer: {
        border: "1px solid #449B23",
        padding: "10px",
        borderRadius: "5px",
    },
    mainAccordion: {
        padding: "0 15px",
    },
    galleryContainer: {
        "& > img": {
            height: "80vh",
        },
    },
    icon: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        width: "60px",
        height: "60px",
        margin: "10% 0  10%",
        "@media (max-width: 767px)": {
            width: "45px",
            height: "45px",
        },
    },
    gradient: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: "36px",
        pointerEvents: "none",
        zIndex: 1,
    },
    workspace: {
        position: "relative",
        width: "100%",
    },
    [theme.breakpoints.up("md")]: {
        stages: {
            padding: "0 18px 16px 18px",
            // marginRight: "18px",
        },
        titleRow: {
            padding: "27px 18px",
            display: "flex",
            justifyContent: "space-between",
            "& > h4": {
                padding: "0px",
            },
            "& > button": {
                padding: "0",
            },
            "& .MuiSvgIcon-root": {
                margin: "-7px",
                fontSize: "35px",
            },
        },
        title: {
            fontSize: "22px",
            fontWeight: "bold",
        },
    },
}));
